import { render, staticRenderFns } from "./ButtonLight.vue?vue&type=template&id=3fa5999e&"
import script from "./ButtonLight.vue?vue&type=script&lang=js&"
export * from "./ButtonLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports